import { BeforeProps } from "@containers/DataTable";
import { ErrorResponse } from '@api/Responses/ErrorResponse';
import { getApproachingDeadline, Return, TApproachingDeadlineResponse } from '@api/apiClient';
import { Grid, Row, Column } from "@components/Grid";
import { Text, TextSize, TextType } from "@components/Text";
import { Trans, useTranslation } from "react-i18next";
import { useQuery } from 'react-query';

const BeforeUnpaidTable = ({
  items,
  isLoading,
}: BeforeProps<Return>) => {
  const { t } = useTranslation();

  const {
    data: dataGetApproachingDeadline,
    isFetching: isFetchingGetApproachingDeadline
  } = useQuery<TApproachingDeadlineResponse, ErrorResponse>({
    queryKey: ['getApproachingDeadline', 'unclaimedUnpaid'],
    queryFn: getApproachingDeadline,
    retry: 1
  });

  const hasLinkedResales = items.some((item) => {
    return item.hasLinkedResales;
  });

  if (!isLoading && !isFetchingGetApproachingDeadline) {
    if (dataGetApproachingDeadline && dataGetApproachingDeadline.countAwaitingPayment) {
      return (
        <div
          style={{
            backgroundColor: "#fce0e3",
            borderRadius: "10px",
            padding: "5px 20px",
            marginBottom: "10px",
          }}
        >
          <Grid>
            <Row>
              <Column phone={12}>
                <Text type={TextType.P} size={TextSize.M}>
                  <b style={{ color: "rgb(88, 21, 28)" }}>
                    {t("awaitingPage.noty_unpaid_returns_title")}
                  </b>
                </Text>
              </Column>
            </Row>
            <Row>
              <Column phone={12}>
                <Text type={TextType.P} size={TextSize.M}>
              <span style={{ color: "rgb(88, 21, 28)" }}>
                <b style={{ color: "rgb(88, 21, 28)" }}>
                  {dataGetApproachingDeadline.countAwaitingPayment}
                </b>{" "}
                -{" "}
                <Trans i18nKey="awaitingPage.noty_unpaid_returns_text" />
              </span>
                </Text>
              </Column>
            </Row>
          </Grid>
        </div>
      );
    }
    if (hasLinkedResales) {
      return (
        <div
          style={{
            backgroundColor: "rgb(255, 243, 205)",
            borderRadius: "10px",
            padding: "5px 20px",
            marginBottom: "20px",
          }}
        >
          <Grid>
            <Row>
              <Column phone={12}>
                <Text type={TextType.P} size={TextSize.M}>
                  <b style={{ color: "rgb(102, 77, 3)" }}>
                    {t("awaitingPage.noty_resale_title")}
                  </b>
                </Text>
              </Column>
            </Row>
            <Row>
              <Column phone={12}>
                <Text type={TextType.P} size={TextSize.M}>
              <span style={{ color: "rgb(102, 77, 3)" }}>
                <Trans i18nKey="awaitingPage.noty_resale_text" />
              </span>
                </Text>
              </Column>
            </Row>
          </Grid>
        </div>
      )
    }
  }

  return null;
}

export default BeforeUnpaidTable;
